
export enum LoaderStatus {
    ApplyingUpdates,
    Loading,
    Loaded,
    GeneratingReports,
    Rendered,
}